import CloseBillingPeriodButtonProperties from "./CloseBillingPeriodButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import CloseBillingPeriodStore from "./CloseBillingPeriodStore";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./CloseBillingPeriodButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import CommentInput from '../../Inputs/CommentInput/CommentInput';
import {useUserContext} from "../../../contexts/UserContext";
import React from "react";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import EventBusyIcon from '@mui/icons-material/EventBusy';

const CloseBillingPeriodButton: React.FC<CloseBillingPeriodButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  billingPeriodId,
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles();

    const i18n = useI18nContext();
    const userStore = useUserContext();
    const commonContext = useCommonContext();
    const store = new CloseBillingPeriodStore(commonContext, billingPeriodId);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const onCommentChange = (newComment: string) => (store.notes = newComment);

    const onOrderStatusSave = async () => {
        const saved = await store.close();
        if (saved) {
            store.closeModal();
            if (onSave) {
                onSave();
            }
        }
    }

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const text = 'Cerrar período';
    
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <EventBusyIcon/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <EventBusyIcon/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={'Cerrar período'} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <CommentInput
                            fullWidth
                            lines={3}
                            onChange={onCommentChange}
                            value={store.notes}
                            className={classes.input}/>
                        <Button
                            loading={store.loading} className={classes.input} onClick={onOrderStatusSave}
                            type={ButtonType.SECONDARY}
                            text={i18n.translate("SAVE")}/>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default CloseBillingPeriodButton;
